/**
 * This file holds the actions/mutations types.
 * For more information about why this is needed see:
 * https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const UPLOAD = "UPLOAD";

export const SAVE_ADDRESS_OF_UPLOADED_IMAGE = "SAVE_ADDRESS_OF_UPLOADED_IMAGE";
export const SAVE_TYPE_OF_UPLOADED_IMAGE = "SAVE_TYPE_OF_UPLOADED_IMAGE";
export const SAVE_DIMENSIONS_OF_UPLOADED_IMAGE = "SAVE_DIMENSIONS_OF_UPLOADED_IMAGE";

export const RESET_UPLOADED_IMAGE_DATA = "RESET_UPLOADED_IMAGE_DATA";

export const UPDATE_SECONDARY_IMAGE = "UPDATE_SECONDARY_IMAGE";
export const RESET_SECONDARY_IMAGE = "RESET_SECONDARY_IMAGE";

export const UPDATE_CHECKERBOARDER = "UPDATE_CHECKERBOARDER";
export const RESET_CHECKERBOARDER = "RESET_CHECKERBOARDER";

export const UPLOAD_CHECKERED_IMAGE = "UPLOAD_CHECKERED_IMAGE";

export const GET_PDM = "GET_PDM";
export const SET_PDM = "SET_PDM";
export const GET_SIZES = "GET_SIZES";
export const SET_SIZES = "SET_SIZES";

export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";

export const SET_SELECTABLE_MODELS_DATA = "SET_SELECTABLE_MODELS_DATA";
export const SET_AVAILABLE_UGC_TOOLS = "SET_AVAILABLE_UGC_TOOLS";
export const SET_HEADER_DESC = "SET_HEADER_DESC";

export const SELECTED_STYLE = "SELECTED_STYLE";
export const SELECTED_STYLE_NAME = "SELECTED_STYLE_NAME";
export const SET_ORDER_STYLES = "SET_ORDER_STYLES";
export const SET_ORDER_STYLES_APPAREL = "SET_ORDER_STYLES_APPAREL";

export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";
export const SET_ENABLE_CONTROLS = "SET_ENABLE_CONTROLS";
export const PREV_VIEW = "PREV_VIEW";
export const REMOVE_VIEW = "REMOVE_VIEW";
export const RESTORE_VIEWS = "RESTORE_VIEWS";

export const SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS = "SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS";
export const SET_CONTACT_DETAILS = "SET_CONTACT_DETAILS";
export const SET_OPT_IN = "SET_OPT_IN";
export const RESET_CONTACT_DETAILS = "RESET_CONTACT_DETAILS";

export const SET_ENABLE_EMAIL_GATEWAY = "SET_ENABLE_EMAIL_GATEWAY";
export const UGC_GATEWAY = "UGC_GATEWAY";

export const USE_SVG_RENDERER = "USE_SVG_RENDERER";
export const ENABLE_SMARTCROP = "ENABLE_SMARTCROP";

export const GENERATE_UGC_SWATCH = "GENERATE_UGC_SWATCH";
export const GET_UGC_PLACEMENT = "GET_UGC_PLACEMENT";

export const GET_CROPPED_UGC_PLACEMENT = "GET_CROPPED_UGC_PLACEMENT";

export const SET_FEATURE = "SET_FEATURE";
export const SET_IMAGE_CATEGORIES = "SET_IMAGE_CATEGORIES";

export const SET_MODEL_RECIPES = "SET_MODEL_RECIPES";
export const GET_PRODUCT_IMAGES_BY_RECIPE_ID = "GET_PRODUCT_IMAGES_BY_RECIPE_ID";

export const ENABLE_AUTO_COLOR_MAPPING = "ENABLE_AUTO_COLOR_MAPPING";
export const SET_IMAGE_LIBRARY_ID = "SET_IMAGE_LIBRARY_ID";
export const SET_IMAGE_LIBRARY_CATEGORY = "SET_IMAGE_LIBRARY_CATEGORY";
export const GET_COLOR_MAPPING_DATA = "GET_COLOR_MAPPING_DATA";
export const SET_COLOR_MAPPING_DATA = "SET_COLOR_MAPPING_DATA";

export const SET_APPAREL_MODELS = "SET_APPAREL_MODELS";
export const SET_PRODUCT_TYPE = "SET_PRODUCT_TYPE";
export const SET_SWITCH_TO_APPAREL = "SET_SWITCH_TO_APPAREL";
export const SET_SWITCH_TO_SHOES = "SET_SWITCH_TO_SHOES";

export const SET_IMAGE_STATUS = "SET_IMAGE_STATUS";
export const SET_SOURCE = "SET_SOURCE";
